import client from './client';

export async function list(params = {}) { const { data } = await client.get('/api/transactions', { params }); return data; }
